module.exports = __webpack_public_path__ + "img/84.334080d6.png";